import React, {Fragment} from 'react';
import {Form, Input} from 'semantic-ui-react';

const WhitelistDomainForm = ({
  whitelistDomain,
  handleTextChanged,
  isReadOnly,
  isBeingEdited,
}) => {
  return (
    <Fragment>
      <Form.Field
        id="form-create-domainName"
        name="domainName"
        disabled={isReadOnly}
        value={whitelistDomain.domainName}
        onChange={handleTextChanged}
        control={Input}
        label="Domain Name"
      />
    </Fragment>
  );
};

export default WhitelistDomainForm;
